export default "__VITE_ASSET__BEyapR2Q__"